'use client';

import React from 'react';
import dynamic from 'next/dynamic';
import { TrendingUp } from 'lucide-react';

const CompletionRadialChart = dynamic(
  () => import('./CompletionRadialChart'),
  { ssr: false, loading: () => <div className="h-48 w-full animate-pulse bg-muted rounded-lg" /> }
);

export default function CompletionRateCard() {
  return (
    <div className="h-full bg-card border border-border rounded-xl shadow-card p-5 flex flex-col card-hover">
      <div className="flex items-start justify-between mb-2">
        <div>
          <p className="text-[13px] font-semibold uppercase tracking-wide text-muted-foreground">
            Completion Rate
          </p>
          <p className="text-xs text-muted-foreground mt-0.5">Sprint W35 · this week</p>
        </div>
        <span className="inline-flex items-center gap-1 text-xs font-semibold text-green-700 bg-green-50 border border-green-200 px-2.5 py-1 rounded-full">
          <TrendingUp size={11} />
          +6% vs last sprint
        </span>
      </div>

      <div className="flex-1 flex items-center justify-center">
        <CompletionRadialChart />
      </div>

      <div className="grid grid-cols-3 gap-3 mt-3 pt-3 border-t border-border">
        <div className="text-center">
          <p className="text-lg font-bold text-foreground font-tabular">34</p>
          <p className="text-[11px] text-muted-foreground mt-0.5">Completed</p>
        </div>
        <div className="text-center border-x border-border">
          <p className="text-lg font-bold text-foreground font-tabular">12</p>
          <p className="text-[11px] text-muted-foreground mt-0.5">In Progress</p>
        </div>
        <div className="text-center">
          <p className="text-lg font-bold text-foreground font-tabular">8</p>
          <p className="text-[11px] text-muted-foreground mt-0.5">Remaining</p>
        </div>
      </div>
    </div>
  );
}